import React from 'react';
import {
  Layout, Button, Upload, message, Tooltip, Popconfirm, Icon, Switch,
} from 'antd';
import { FaTable } from 'react-icons/fa';
import { find, isEmpty } from 'lodash';
import { TiArrowLeft } from 'react-icons/ti';
import PageWithTopbar from '../PageWithTopbar';
import DataPageGrid from './DataPageGrid';
import DataPageAdder from './DataPageAdder';
import ErrorMsgModal from './DataPageErrorMsgModal';
import SideMenu from './SideMenu';
import {
  SideBar, Main, ModalWrapper, Back, Right, Loading, DataButton, FooterButton,
  DataLink, BulkEditButtons, DataLinkText, StyledIcon, SwitchLabel, hideFileList,
  BadRequestCard,
} from './styles';
import {
  last, allButLast, snakeToCamel, camelToSnake, intersection, orderingString,
  buildFilters, copyToClipboard,
} from '../../helpers';
import {
  UPLOAD_SUCCESS, BULK_DELETE_DATA_CONFIRMATION, BULK_DELETE_DATA_SUCCESS,
  UNLINK_CONFIRMATION, UNLINK_AND_COPY_CONFIRMATION, LINKED_TEXT, UNLINKED_TEXT,
  UPLOAD_FAILURE, DOWNLOAD_HAPPENING, DOWNLOAD_FAILED, UNLINKED_NESTED_ROW,
  COPY_TO_CLIPBOARD, COPY_PREVIOUS_WEEK_SUCCESS,
} from '../../constants/text.constants';
import {
  EDITABLE_TYPES, GANTT_TYPES,
} from '../../constants/grid.constants';
import DataPageModal from './DataPageModal';
import DisabledTooltip from '../DisabledTooltip';
import { EXTRA_DATA_PAGES } from '../../constants/dataPages.constants';

export const ConditionalPopConfirm = ({
  disabled, children, popTitle, okText, okType, onConfirm, ...rest
}) => disabled
  ? <span {...rest}>{children}</span>
  : (
    <Popconfirm
      {...okText}
      {...okType}
      title={popTitle}
      onConfirm={onConfirm}
      {...rest}
    >
      {children}
    </Popconfirm>
  );

class DataPageComponent extends React.Component {
  state = {
    modalVisible: true,
    modalHistory: [],
    selected: {},
    nestedSelect: {},
    offset: 0,
    ordering: '',
    filters: {},
    openMenus: [],
    gantt: false,
    lastUploaded: {},
    menuSearch: '',
  };

  componentDidMount() {
    // A hack to Bkt-React grid to identify inline editing is initiated,
    // without modifying Bkt-React.
    //
    // This is used to control whether the Show/Hide column should be disabled,
    // because toggling the visibility of column while inline-editing a row,
    // would muck up inline editing, which it shouldn't. This is merely a quick and
    // easy solution without going through the hurdle of modifying a complicated
    // library.
    //
    // And, I cannot setState in here because it will also muck up Bkt-React grids
    // editing capability. This is currently the easiest way to achieve this.
    //
    // TODO: We know this is ugly. We know there must be a better way, but it
    // all requires modifiying Bkt-React and that is massive hassle just to achieve
    // a small goal.
    document.addEventListener('click', () => {
      const findActiveEdit = document.getElementsByClassName('active-edit');
      if (findActiveEdit && findActiveEdit.length > 0) {
        const getShowHideGridColumnTree = document.getElementById('DCRPShowHideGridColumnTree');
        if (getShowHideGridColumnTree) {
          getShowHideGridColumnTree.setAttribute(
            'style', 'pointer-events: none; opacity: .4;',
          );
        }
      } else {
        this.setShowHideColumnTreeToEnabled();
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { persistParams } = this.props;
    // If the path (related to scenario, datatype and startDate) has been changed.
    // Make sure the selctions are cleared.
    if (persistParams.pathname !== prevProps.persistParams.pathname) {
      this.clearSelected();
      this.clearQueryParameters();
    }
  }

  setShowHideColumnTreeToEnabled = () => { // Please see the comments in componentDidMount.
    const getShowHideGridColumnTree = document.getElementById('DCRPShowHideGridColumnTree');
    if (getShowHideGridColumnTree) getShowHideGridColumnTree.removeAttribute('style');
  }

  getMeta = (item_type) => {
    const { dataTypes } = this.props;
    const currentMeta = find(dataTypes, { item_type }) || {};
    const children = !isEmpty(currentMeta) ? currentMeta.columns.filter(x => x.type === 'child') : [];
    const childMeta = children.map(child => this.getMeta(camelToSnake(child.lookup)));
    return { currentMeta, childMeta };
  }

  onAdd = (api) => {
    const { currentItemType, itemLookUps } = this.props;
    const { currentMeta: { columns, item_display_name } } = this.getMeta(currentItemType);
    return !isEmpty(columns) && this.addModal({
      title: `Adding to ${item_display_name}`,
      component: (
        <DataPageAdder
          meta={this.getMeta(currentItemType)}
          api={api}
          lookups={itemLookUps.data}
        />
      ),
    });
  }

  onBulkEdit = () => {
    const { selected } = this.state;
    const { currentItemType } = this.props;
    const rowsToEdit = Object.values(selected);

    return rowsToEdit.length > 0 && this.addModal({
      title: `Bulk Editing ${rowsToEdit.length} Items`,
      data: { type: currentItemType, content: rowsToEdit },
      bulkEditing: true,
    });
  }

  onBulkDelete = (queryParameters) => {
    const { selected } = this.state;
    const { gridApi, currentItemType } = this.props;
    const rowsToDelete = Object.values(selected).map(item => item.id);
    gridApi.bulkDelete(
      {
        data: { ids: rowsToDelete },
        successCallback: () => gridApi.get({
          queryParameters,
          successCallback: () => {
            this.clearSelected();
            message.success(BULK_DELETE_DATA_SUCCESS(selected));
          },
        }),
      },
      currentItemType,
    );
  }

  onBulkDeleteNested = (queryParameters, modal, successCallback) => {
    const { nestedSelect } = this.state;
    const { gridApi } = this.props;
    const { data: { type } } = modal;
    const rowsToDelete = Object.values(nestedSelect).map(item => item.id);

    gridApi.bulkDelete(
      {
        data: { ids: rowsToDelete },
        successCallback,
      },
      type,
    );
  }

  modalButtons = history => (
    <div>
      <Back onClick={this.backModal}>
        <TiArrowLeft size={24} />
      </Back>
      <span>
        {history.map((data, i) => (
          <span key={data.title}>
            {i > 0 && <Right />}
            <span>{data.title}</span>
          </span>
        ))}
      </span>
    </div>
  )

  addModal = (modal) => {
    const { modalHistory } = this.state;
    return this.setState({
      modalHistory: [...modalHistory, modal],
    });
  }

  updateModalContent = (content) => {
    const { modalHistory } = this.state;
    const currentModal = last(modalHistory);
    return this.setState({
      // Update the data displayed in modal.
      modalHistory: [
        ...allButLast(modalHistory),
        { ...currentModal, data: { ...currentModal.data, content } },
      ],
      selected: this.updateModalSelectState(content),
    });
  }

  updateModalContentForNested = (updatedRow, childName) => {
    const { modalHistory } = this.state;
    const currentModal = last(modalHistory);
    const content = updatedRow[childName];
    // Row requires update which is important for edit the linked data - id would change.
    const row = { ...currentModal.row, ...updatedRow };
    return this.setState({
      // Update the data displayed in modal.
      modalHistory: [
        ...allButLast(modalHistory),
        { ...currentModal, data: { ...currentModal.data, content, row } },
      ],
      // Update the data displayed in modal for deletion.
      // There is no bulk edit in nested item.
      nestedSelect: {},
    });
  }

  // Update the data in selected state so that the old
  // values don't revive again if the site is not refreshed.
  updateModalSelectState = content => content.reduce((obj, item) => {
    const newObj = { ...obj };
    newObj[item.id] = item;
    return newObj;
  }, {});

  backModal = () => {
    const { modalHistory } = this.state;
    return this.setState({
      modalHistory: allButLast(modalHistory),
    });
  }

  hideModal = () => this.setState({
    modalHistory: [],
  })

  onRowSelect = (checkbox, nested) => {
    const { selected, nestedSelect } = this.state;
    const { rowData, originRow, checked } = checkbox;
    const newObj = nested ? { ...nestedSelect } : { ...selected };

    if (checked) {
      newObj[rowData.id] = originRow;
    } else if (newObj[rowData.id]) {
      delete newObj[rowData.id];
    }

    this.setState({ [nested ? 'nestedSelect' : 'selected']: newObj });
  }

  selectRows = (rows, editingControlledBy) => {
    const { selected } = this.state;
    const {
      editable_if_link_status_equals, editable_if_column_is_empty,
    } = editingControlledBy;

    // Restrict only editable rows can be selected for bulk edit and delete.
    let onlyEditableRows = rows;
    if (editable_if_column_is_empty) {
      const cameledEditingColumnIsEmpty = snakeToCamel(editable_if_column_is_empty);
      onlyEditableRows = rows.filter(row => !row[cameledEditingColumnIsEmpty] || row[cameledEditingColumnIsEmpty] === '');
    }

    if (editable_if_link_status_equals) {
      onlyEditableRows = rows.filter(row => row.linkStatus === editable_if_link_status_equals);
    }

    const newRows = onlyEditableRows.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {});

    return this.setState({
      selected: { ...selected, ...newRows },
    });
  }

  clearSelected = () => this.setState({
    selected: {},
    nestedSelect: {},
  })

  updateConfig = ({ limit, ...config }, onPageLimit) => {
    if (limit) onPageLimit(limit);
    this.setState({
      ...config,
    });
  }

  onUpload = ({ file }, get) => {
    this.setState({ fileUploading: true });

    if (file.status === 'done') {
      get();
      message.success(UPLOAD_SUCCESS(file.name));
    }

    if (file.status === 'error') {
      // backend define this in either an array or string format.
      let errMsg;
      let openIssueModal;
      try {
        errMsg = JSON.parse(file.response.detail);
        openIssueModal = () => {
          message.destroy();
          ErrorMsgModal(
            'Upload errors (first 100)',
            JSON.parse(file.response.detail),
          );
        };
      } catch {
        errMsg = file.response.detail;
      }

      message.error(<>
        <span>{UPLOAD_FAILURE(file.name)}</span>
        <br />
        {
          (typeof errMsg === 'string')
            ? (
              <span>{errMsg}</span>
            ) : (
              <a href onClick={openIssueModal}>
                Click for detailed error information.
              </a>
            )
        }
      </>, 10);
    }

    if (file.status !== 'uploading') {
      this.setState({ fileUploading: false });
    }

    this.setState({ lastUploaded: { name: file.name, status: file.status } });
    return null;
  }

  onMenuClick = ({ menu, onMenuClick }) => {
    this.clearQueryParameters();
    return onMenuClick(menu);
  }

  onMenuGroupClick = openMenus => this.setState({
    openMenus,
  })

  onGantt = () => this.setState(({ gantt }) => ({ gantt: !gantt }))

  clearQueryParameters = () => this.setState({
    offset: 0,
    ordering: '',
    filters: {},
    selected: {},
    nestedSelect: {},
    lastUploaded: {},
  })

  handleKeyMenuSearch = (event) => {
    this.setState({ menuSearch: event.target.value.toLowerCase().replace(/[^a-zA-Z ]/g, '') });
  }

  handleDownloadFile = (srcUrl, meta) => {
    message.info(DOWNLOAD_HAPPENING(meta.currentMeta.item_display_name), 3);
    // Download now uses iframe update as big organisation may have different
    // policy on popups which might be used by modules.
    document.getElementById('downloadTrigger').src = srcUrl;
  }

  handleCopyPreviousWeek = (queryParameters) => {
    const { gridApi, onCopyPreviousWeek } = this.props;
    this.setState({ copyingPreviousWeek: true });
    const onSuccess = () => {
      this.setState({ copyingPreviousWeek: false });
      message.success(COPY_PREVIOUS_WEEK_SUCCESS);
      gridApi.getWithLookups({
        queryParameters,
      });
    };

    const onFailed = () => {
      this.setState({ copyingPreviousWeek: false });
    };
    // Called put command on copy previous week
    onCopyPreviousWeek(onSuccess, onFailed);
  }

  handleCopyToClipBoard = (meta) => {
    const { onCSV: { downloadForCopyToClipboard } } = this.props;
    message.info(DOWNLOAD_HAPPENING(meta.currentMeta.item_display_name), 3);
    // Basic XHR will do in here, no need to store stuff in Redux store.
    const basicXHR = new XMLHttpRequest();
    basicXHR.open('GET', downloadForCopyToClipboard());
    basicXHR.send();
    // eslint-disable-next-line func-names
    basicXHR.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        copyToClipboard(basicXHR.responseText);
        message.info(COPY_TO_CLIPBOARD, 3);
      } else {
        message.error(DOWNLOAD_FAILED, 3);
      }
    };
  }

  handleChangeSplitPanel = (size) => {
    const { gridApi: { set }, persistParams } = this.props;
    set('persistParams', { ...persistParams, dataPageSideBarSplitPaneSize: size });
  }

  render() {
    const {
      config,
      persistParams,
      dataIsLinked,
      unlinkData,
      dataTypes,
      dataView: {
        loadingQueue,
        data,
      },
      callbackErrorObject,
      removeErroredStatus,
      itemLookUps,
      currentItemType,
      onMenuClick,
      gridApi,
      onBulkEdit,
      onCSV: {
        upload, download, downloadCSV,
      },
      onPageLimit,
      onCheckToToggleColumns,
      isCheckingOptimising,
      isOptimising,
      availableVolumeDataSources,
      volumeFromSource,
      currentVolume,
      onApplyVolume,
      onUpdateVolumes,
      updateVolumeStatus,
      unlinkDataStatus,
      bulkDelete,
    } = this.props;

    const {
      modalVisible, modalHistory, selected, nestedSelect, offset, fileUploading,
      copyingPreviousWeek, ordering, filters, openMenus, gantt, lastUploaded, menuSearch,
    } = this.state;

    const { limit } = persistParams;

    const modal = last(modalHistory);

    const meta = this.getMeta(currentItemType);

    const hasBulkEditable = (currentMeta) => {
      const columnTypes = currentMeta.columns.map(({ type }) => type);
      const editableTypes = Object.keys(EDITABLE_TYPES);
      return intersection(columnTypes, editableTypes);
    };

    const isNotBulkEditable = isCheckingOptimising || isOptimising
      || (!isEmpty(meta.currentMeta) && !hasBulkEditable(meta.currentMeta));

    const isNotEditable = isCheckingOptimising || isOptimising || !meta.currentMeta.editable;

    const isNotDeletable = isCheckingOptimising || isOptimising || !meta.currentMeta.can_delete;

    const isNotAddable = isCheckingOptimising || isOptimising || !meta.currentMeta.can_create;

    const allItemsSelected = Object.keys(selected).length === limit;

    const isNotActivePlan = persistParams.scenario !== '0';

    const uploadNotAvailable = isCheckingOptimising || isOptimising
      || !meta.currentMeta.upload_available;

    const copyEnabled = meta.currentMeta.can_copy_data_to_clipboard;

    const isBulkDeleting = !isEmpty(bulkDelete);

    const noItemsSelected = isEmpty(selected);

    const showSpinner = !isEmpty(loadingQueue.concat(unlinkDataStatus)) || isBulkDeleting;

    const queryParameters = {
      limit,
      offset,
      ordering: orderingString(ordering, meta),
      ...buildFilters(filters),
    };

    return (
      <Layout>
        {
          !callbackErrorObject
            && (meta.currentMeta.data_group || EXTRA_DATA_PAGES[currentItemType]) ? (
              <SideBar
                bg="white"
                width={250}
              >
                <SideMenu
                  selectedKeys={[currentItemType]}
                  defaultOpenKeys={isEmpty(openMenus) ? [meta.currentMeta.data_group] : openMenus}
                  onSelect={menu => this.onMenuClick({ menu, onMenuClick })}
                  defaultSelectedKeys={[currentItemType]} // AntD requires this an array.
                  menuItems={dataTypes}
                  extras={EXTRA_DATA_PAGES}
                  onOpenChange={this.onMenuGroupClick}
                  onChangeSideBarSplitSize={this.handleChangeSplitPanel}
                  persistParams={persistParams}
                  menuSearch={menuSearch}
                  onKeyMenuSearch={this.handleKeyMenuSearch}
                  onCheckToToggleColumns={onCheckToToggleColumns}
                />
              </SideBar>
            ) : ''
        }
        <Main bg="white" position="relative">
          <iframe
            title="Hidden download trigger"
            width="0"
            height="0"
            style={{ position: 'absolute', display: 'none' }}
            id="downloadTrigger"
          />

          {EXTRA_DATA_PAGES[currentItemType]
            ? EXTRA_DATA_PAGES[currentItemType].component({
              persistParams,
              availableVolumeDataSources,
              volumeFromSource,
              onApplyVolume,
              currentVolume,
              onUpdateVolumes,
              updateVolumeStatus,
              volumeIsLinked: dataIsLinked,
              isOptimising,
              isCheckingOptimising,
              orderDateDefaultVolumeDate: config.orderDateDefaultVolumeDate,
            })
            : (
              <PageWithTopbar
                p={1}
                leftSpan={4}
                rightSpan={20}
                leftComponent={
                  <>
                    <Tooltip title="Refresh Data">
                      <Button
                        style={{ margin: '0 12px 0 -8px ' }}
                        icon="reload"
                        onClick={() => {
                          if (callbackErrorObject) {
                            removeErroredStatus();
                          }
                          gridApi.getWithLookups({
                            queryParameters,
                          });
                        }}
                      />
                    </Tooltip>

                    {
                      GANTT_TYPES.includes(currentItemType) && (
                        <div>
                          <SwitchLabel>Gantt Mode</SwitchLabel>
                          <Switch onChange={this.onGantt} />
                        </div>
                      )
                    }
                  </>
                }
                rightComponent={(
                  <>
                    <BulkEditButtons compact>
                      <Tooltip title="Select All on Page">
                        <Button
                          disabled={isNotEditable || allItemsSelected}
                          icon="check-square"
                          onClick={() => this.selectRows(
                            data.results,
                            meta.currentMeta.editing_controlled_by,
                          )}
                        />
                      </Tooltip>
                      <DisabledTooltip
                        predicates={{
                          isOptimising,
                          isNotEditable,
                          isNotBulkEditable,
                          noItemsSelected,
                        }}
                      >
                        <Button
                          disabled={isNotEditable || isNotBulkEditable || noItemsSelected}
                          icon="edit"
                          onClick={this.onBulkEdit}
                        >
                          Bulk Edit
                        </Button>
                      </DisabledTooltip>

                      <ConditionalPopConfirm
                        placement="topLeft"
                        icon={<StyledIcon type="exclamation-circle" color="red" />}
                        popTitle={BULK_DELETE_DATA_CONFIRMATION(selected)}
                        okText="Delete data"
                        okType="danger"
                        onConfirm={() => this.onBulkDelete(queryParameters)}
                        disabled={isNotDeletable || isNotEditable || noItemsSelected}
                      >
                        <DisabledTooltip
                          predicates={{
                            isOptimising,
                            isNotDeletable,
                            isNotEditable,
                            noItemsSelected,
                          }}
                        >
                          <Button disabled={isNotDeletable || isNotEditable || noItemsSelected}>
                            <Icon
                              type="delete"
                              theme={(isNotDeletable || isNotEditable || noItemsSelected) ? 'outlined' : 'twoTone'}
                              twoToneColor="#f00"
                            />
                            Delete Selected
                          </Button>
                        </DisabledTooltip>
                      </ConditionalPopConfirm>
                      <Tooltip title="Deselect All">
                        <Button
                          disabled={isNotEditable || noItemsSelected}
                          icon="close-square"
                          onClick={this.clearSelected}
                        />
                      </Tooltip>
                    </BulkEditButtons>
                    <DisabledTooltip
                      predicates={{
                        isOptimising,
                        isNotEditable,
                        isNotAddable,
                      }}
                    >
                      <DataButton
                        disabled={isNotEditable || isNotAddable}
                        icon="plus"
                        onClick={() => this.onAdd({
                          get: () => gridApi.get({
                            queryParameters,
                            successCallback: this.hideModal,
                          }),
                          post: gridApi.post,
                        })}
                      >
                        Add Data
                      </DataButton>
                    </DisabledTooltip>
                    <DataButton
                      icon="download"
                      onClick={() => this.handleDownloadFile(downloadCSV(), meta)}
                    >
                      CSV
                    </DataButton>
                    <DisabledTooltip
                      predicates={{
                        copyDisabled: !copyEnabled,
                      }}
                    >
                      <DataButton
                        icon="copy"
                        disabled={!copyEnabled}
                        onClick={() => this.handleCopyToClipBoard(meta)}
                      >
                        Copy
                      </DataButton>
                    </DisabledTooltip>
                    <Upload
                      className={hideFileList}
                      onChange={file => this.onUpload(file, () => gridApi.get(queryParameters))}
                      accept=".tsv,.txt,.csv"
                      action={upload()}
                      disabled={uploadNotAvailable || fileUploading}
                    >
                      <DisabledTooltip
                        predicates={{
                          isOptimising,
                          uploadNotAvailable,
                        }}
                      >
                        <DataButton
                          disabled={uploadNotAvailable || fileUploading}
                          icon={fileUploading ? 'loading' : 'upload'}
                          status={lastUploaded.status}
                        >
                          {lastUploaded.name || 'Upload'}
                        </DataButton>
                      </DisabledTooltip>
                    </Upload>
                    <DisabledTooltip
                      predicates={{
                        isOptimising,
                        uploadNotAvailable,
                      }}
                    >
                      <DataButton
                        disabled={uploadNotAvailable || fileUploading || isNotAddable || isNotEditable || copyingPreviousWeek}
                        icon={copyingPreviousWeek ? 'loading' : 'forward'}
                        onClick={() => this.handleCopyPreviousWeek(queryParameters)}
                      >
                        Import Previous Week Data
                      </DataButton>
                    </DisabledTooltip>
                  </>
                )}
              >
                <Loading
                  spinning={showSpinner}
                  {...!isEmpty(unlinkDataStatus) && { useupdatingtext: true }}
                />
                { // Component is automatically unmounted when the key is different.
                  // Such unmount is needed because Bkt-grid does not remove the delete status
                  // when the data type has changed.
                  !callbackErrorObject && data.results
                    ? (
                      <DataPageGrid
                        key={currentItemType}
                        config={config}
                        rows={data}
                        lookups={itemLookUps.data}
                        meta={meta}
                        persistParams={persistParams}
                        addLinkColumn={isNotActivePlan && dataIsLinked}
                        isNotEditable={isNotEditable}
                        isNotDeletable={isNotDeletable}
                        gridApi={gridApi}
                        setShowHideColumnTreeToEnabled={this.setShowHideColumnTreeToEnabled}
                        addModal={this.addModal}
                        checkedState={selected}
                        onSelect={this.onRowSelect}
                        page={{
                          offset, limit, ordering, filters,
                        }}
                        updateConfig={useConfig => this.updateConfig(useConfig, onPageLimit)}
                        gantt={gantt}
                      />
                    ) : (
                      <BadRequestCard>
                        <FaTable />
                        <h1>
                          Data could not be retrieved. Please refresh the page.
                        </h1>
                      </BadRequestCard>
                    )
                }
                {isNotActivePlan && meta.currentMeta.is_linkable
                  && (
                    <DataLink>
                      {dataIsLinked
                        ? (
                          <>
                            <Icon type="link" />
                            <DataLinkText>
                              {LINKED_TEXT}
                            </DataLinkText>
                            <Popconfirm
                              placement="topLeft"
                              icon={<StyledIcon type="exclamation-circle" color="red" />}
                              title={UNLINK_CONFIRMATION}
                              okText="Unlink this Data"
                              okType="danger"
                              onConfirm={() => unlinkData(false, queryParameters)}
                            >
                              <FooterButton icon="disconnect" type="danger">
                                Unlink
                              </FooterButton>
                            </Popconfirm>
                            <Popconfirm
                              placement="topLeft"
                              icon={<StyledIcon type="exclamation-circle" color="red" />}
                              title={UNLINK_AND_COPY_CONFIRMATION}
                              okText="Unlink this Data"
                              okType="danger"
                              onConfirm={() => unlinkData(true, queryParameters)}
                            >
                              <FooterButton icon="disconnect" type="danger">
                                Copy and Unlink
                              </FooterButton>
                            </Popconfirm>
                          </>
                        ) : UNLINKED_TEXT
                      }
                    </DataLink>
                  )
                }
                {modalHistory[0] && (
                  <ModalWrapper
                    maskClosable={false}
                    hasGrid={!isEmpty(modal.data)}
                    centered
                    footer={null}
                    visible={modalVisible}
                    onOk={this.hideModal}
                    onCancel={this.hideModal}
                    width={1000}
                    title={this.modalButtons(modalHistory)}
                  >
                    {isEmpty(modal.data)
                      ? modal.component
                      : (
                        <DataPageModal
                          {...{
                            modal,
                            itemLookUps,
                            gridApi,
                            loadingQueue,
                            meta,
                            onBulkEdit,
                            isNotEditable,
                            queryParameters,
                          }}
                          page={{
                            offset, limit, ordering, filters,
                          }}
                          getMeta={this.getMeta}
                          updateModalContent={this.updateModalContent}
                          updateModalContentForNested={this.updateModalContentForNested}
                          addModal={this.addModal}
                          checkedState={nestedSelect}
                          onSelect={cb => this.onRowSelect(cb, true)}
                          onBulkDeleteNested={this.onBulkDeleteNested}
                          onHideModalNestedItemChanged={() => {
                            setTimeout(() => message.info(UNLINKED_NESTED_ROW), 2000);
                            this.hideModal();
                          }}
                        />
                      )
                    }
                  </ModalWrapper>
                )}
              </PageWithTopbar>
            )
          }
        </Main>
      </Layout>
    );
  }
}

export default DataPageComponent;
